var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-wrap',[_c('vehicle-manage-panel',{attrs:{"source":"hik","use-hik-api":true,"readonly":true,"extended-filters":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }